export const navigationItems = [
  {
    title: "Details",
    url: "/organization/details",
    value: "details",
  },
  { title: "Members", url: "/organization/members", value: "members" },
  { title: "Groups", url: "/organization/groups", value: "groups" },
  {
    title: "Activity log",
    url: "/organization/activity-log",
    value: "activity-log",
  },

  { title: "Receipts", url: "/organization/receipts", value: "receipts" },

  {
    title: "Suborganizations",
    url: "/organization/suborganizations",
    value: "suborganizations",
  },
  {
    title: "Terminals",
    url: "/organization/terminals",
    value: "terminals",
  },
]

export const profileNavigationItems = [
  { title: "Account", url: "/profile/account", value: "account" },
  {
    title: "Notifications",
    url: "/profile/notifications",
    value: "notifications",
  },
  { title: "Receipts", url: "/profile/receipts", value: "receipts" },
]

export const ORGANIZATION_MEMBERS_PATH = "/organization/members"
export const ORGANIZATION_GROUPS_PATH = "/organization/groups"
